import { render, staticRenderFns } from "./TakePay.vue?vue&type=template&id=1a65127b&scoped=true"
import script from "./TakePay.vue?vue&type=script&lang=js"
export * from "./TakePay.vue?vue&type=script&lang=js"
import style0 from "./TakePay.vue?vue&type=style&index=0&id=1a65127b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65127b",
  null
  
)

export default component.exports